<div class="card">
    <div class="card-body">
        <div class="row mt-3 mx-2 container-title">
            <div class="col-lg-6 col-sm-12 col-md-9">
                <h5 class="title_five" style="margin-top: 2rem; font-size: large;">Article List</h5>
            </div>

            <div class="col-lg-6 col-sm-12 col-md-9 pre-precurement-filters">

                <div class="overlay">
                    <div class="article-options-container form_inputFields">
                        <div class="article-btn" *ngIf="stateSelected.state_code === 'KA'">
                            <a target="_blank" class="article-list-link" href="https://www.shcilestamp.com/pdf/state/Karnataka/KA_ARTICLES.pdf">shcilestamp.com - List of Articles for Karnataka</a>
                            <!-- <p-button label="" (click)="getKarnatakaArticlesDetails()"
                                styleClass="p-button-sm-outline" class="btn"></p-button> -->
                            <button (click)="getKarnatakaArticlesDetails()" class="button-style" type="button">
                                <i class="pi pi-download"
                                    style="position: absolute; margin-top:0px;font-size: 1.1rem !important;"></i>
                                <span style="padding-left: 30px;">KA Articles List
                                </span>
                            </button>
                        </div>
                        <div class="article-dropdown ms-2">
                            <span class="form_field ms-2"> State</span>
                            <span class="color_red">*</span>
                            <div style="display: block; ">
                                <app-dropdown class="custom-dropdown state-dropdown" [options]="stateData" [(ngModel)]="stateSelected"
                                    placeholder="select state" [filter]="true" filterBy="state_name"
                                    (onChange)=onStateChange() optionLabel="state_name"></app-dropdown>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>
        <div class="row m-2 mt-3 article-table-container">
            <input type="text" class="form-control mb-1" style="font-size: small; font-weight: 700;"
                placeholder="Search by Article Name" [formControl]="searchControl" (input)="filterArticles()" />
            <app-data-table
                [columns]="columns"
                [data]="articles"
                [paginator]="false"
                [scrollable]="true"
                scrollHeight="calc(100vh - 260px)"
                emptyMessage="No Records Found">
            </app-data-table>
        </div>


    </div>
</div>